import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Typography, Box } from '@material-ui/core'
import { Home as HomeIcon, Build as BuildIcon } from '@material-ui/icons'
import { useStyles } from './styles'
import { CowIcon } from 'src/assets/svg'
import ROUTES from 'src/constants/routes'

export const UnderConstruction: React.FC = () => {
  const styles = useStyles()
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(ROUTES.DASHBOARD)
  }

  return (
    <Box className={styles.container}>
      <div className={styles.content}>
        <Box className={styles.iconContainer}>
          <Box className={styles.errorIcon}>
            <BuildIcon className={styles.icon} />
            <Box className={styles.cowIconWrapper}>
              <CowIcon className={styles.cowIcon} />
            </Box>
          </Box>
        </Box>

        <Typography variant='h2' className={styles.title}>
          Página em construção 🚧
        </Typography>

        <Typography variant='body1' className={styles.description}>
          Estamos preparando algo novo por aqui! Essa funcionalidade ainda está sendo desenvolvida. Volte em breve para
          conferir as novidades.
        </Typography>

        <Box className={styles.actionsContainer}>
          <Button
            variant='contained'
            color='primary'
            size='large'
            onClick={handleGoHome}
            className={styles.primaryButton}
            startIcon={<HomeIcon />}
          >
            Voltar para o início
          </Button>
        </Box>
      </div>
    </Box>
  )
}
